<template>
    <div>
        <div class="page-filter-box">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input v-model="params.searchValue" class="input-with-select" size="small" placeholder="请输入用户ID"></el-input>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.joinStatus" placeholder="请选择" size="small">
                        <el-option label="不限制参与度" value=""></el-option>
                        <el-option label="仅看参与了活动的" :value="1"></el-option>
                        <el-option label="仅看回答了问题的" :value="2"></el-option>
                        <el-option label="仅看回答了部分问题的" :value="3"></el-option>
						<el-option label="仅看回答了全部问题的" :value="4"></el-option>
                    </el-select>
                </el-col>
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
				    <el-select v-model="params.isNew" placeholder="请选择" size="small">
				        <el-option label="不限制是否新用户" value=""></el-option>
				        <el-option label="仅看新用户" :value="1"></el-option>
				        <el-option label="仅看老用户" :value="0"></el-option>
				    </el-select>
				</el-col>
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
				    <el-select v-model="params.isShare" placeholder="请选择" size="small">
				        <el-option label="不限制是否分享" value=""></el-option>
				        <el-option label="仅看未分享的" :value="0"></el-option>
				        <el-option label="仅看分享过的" :value="1"></el-option>
				    </el-select>
				</el-col>
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
				    <el-select v-model="params.couponStatus" placeholder="请选择" size="small">
				        <el-option label="不限制优惠券使用情况" value=""></el-option>
				        <el-option label="仅看未领取的" :value="1"></el-option>
				        <el-option label="仅看领取了且未使用的" :value="2"></el-option>
						<el-option label="仅看领取了且已使用的" :value="3"></el-option>
				    </el-select>
				</el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4" class="page-filter-btns">
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
            </el-row>
        </div>
        
        <div class="page-list-box">
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
            >
                <el-table-column prop="id" label="用户（ID 名称）" min-width="150">
					<template slot-scope="scope">
						{{scope.row.userId}} <span class="color-danger">（{{scope.row.userName}}）</span>
					</template>
				</el-table-column>
                <el-table-column prop="joinType" label="参与度" >
					<template slot-scope="scope">
						<p>{{scope.row.joinStatusView}}</p>
						<p>回答正确问题数：<span>{{`${scope.row.answerNum}`}}</span></p>
					</template>
				</el-table-column>
                <el-table-column label="参与时间" :min-width="180">
					<template slot-scope="scope">
						<p>参与时间：<span v-if="scope.row.joinTime">{{`${scope.row.joinTime}`}}</span></p>
						<p>分享时间：<span v-if="scope.row.shareTime">{{`${scope.row.shareTime}`}}</span></p>
					</template>
				</el-table-column>
                <el-table-column prop="isNewView" label="是否新用户">
					<template slot-scope="scope">
						{{scope.row.isNewView}}
					</template>
				</el-table-column>
                <el-table-column prop="isShareView" label="是否分享" >
					<template slot-scope="scope">
						{{scope.row.isShareView}}
					</template>
				</el-table-column>
                <el-table-column prop="userCouponId" label="优惠券使用情况">
					<template slot-scope="scope">
						<p>使用情况：<span v-if="scope.row.couponStatusView">{{`${scope.row.couponStatusView}`}}</span></p>
						<p>优惠金额：<span v-if="scope.row.couponPrice">{{`${scope.row.couponPrice}`}}</span></p>
					</template>
				</el-table-column>
                <el-table-column prop="assistNum" label="助力人数" >
                </el-table-column>
                <el-table-column fixed="right" label="操作">
                    <template slot-scope="scope">                        
						<el-link :href="`/user/fans/edit/${scope.row.userId}`" class="blue"  target="_blank">查看详情</el-link>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="getDataList"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0">
            </el-pagination>
        </div>
        
    </div>
</template>

<script>

const defaultParams = {
    pageNo: 1,    
    id:'',
    joinStatus: '',
	isNew:'',
	isShare:'',
	searchType:1,
	couponStatus:''
}
export default {
    components:{},
	props:{
	    id: {
	        type: [Number, String],
	        default: ""
	    }
	},
    data(){
        return{
            data: null,
            dataList: null,
            params:{
                ...defaultParams,
                pageNo: parseInt(this.$route.query.pageNo || 1),
                pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0]),
                id: this.$route.query.id || '',
                joinStatus: this.$route.query.searchValue || '',
                isNew: parseInt(this.$route.query.status) || '',
				isShare: parseInt(this.$route.query.status) || '',
				couponStatus: this.$route.query.couponStatus || '',
            },
            listLoading: true,
			
          
        }
    },
    mounted() {
        this.getDataList();
    },
    methods: {
        //获取列表
        getDataList() {
            this.listLoading = true;
            this.$request({
                url: "/quiz/award/statistics",
                method: "POST",
                data: {
                    ...this.params,
					id:this.id
                },
            })
			.then((res) => {
				const { state, msg, result } = res.data;
				if ( state == 1 && result) {
					this.data = result;
					this.dataList = result.result || [];
                   
				} else {
					this.$message.error(msg || "请求失败");
				}
			})
			.catch(() => {
				this.$message.error("请求错误");
			})
			.finally(() => {
				this.listLoading = false;
			});
        },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.params = {
                ...defaultParams,
                pageSize: this.params.pageSize,
            };
            this.getDataList();
        },
    }
}
</script>

<style lang="scss" scoped>
.blue{
   color:#409eff;
   text-decoration:none;
}
</style>